<template>
    <div
        class="step"
        style="
            width: calc(100% - 3%);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        "
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        blocksMap: {
            type: Object,
            default: () => {}
        },
        elementsMap: {
            type: Object,
            default: () => {}
        },
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetStepBlock"
}
</script>
